import { render, staticRenderFns } from "./FundamentalsHistorical.vue?vue&type=template&id=6d0c585c&scoped=true&"
import script from "./FundamentalsHistorical.vue?vue&type=script&lang=js&"
export * from "./FundamentalsHistorical.vue?vue&type=script&lang=js&"
import style0 from "./FundamentalsHistorical.vue?vue&type=style&index=0&id=6d0c585c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c585c",
  null
  
)

export default component.exports